import React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const IconWrapper: React.FC<Props> = ({ children, className }) => (
  <div
    className={cn('size-11 flex items-center justify-center m-1', className)}
  >
    {children}
  </div>
);

export default IconWrapper;
